import { useTranslation } from 'react-i18next';
import { RootNavigationLink } from '@cbridge-utils/navigation';
import { RouteSegments } from '../routingClientAdmin.interface';
import { useClientPageVisibility } from './useClientPageVisibility';

export const useClientRootNavigation = (): RootNavigationLink[] => {
  const { t } = useTranslation();
  const { isTradingVisible, isMarkoutVisible } = useClientPageVisibility();

  const links: RootNavigationLink[] = [
    {
      href: `/${RouteSegments.Root.Dashboard}`,
      title: t('text:navigation.dashboard.title'),
    }, {
      href: `/${RouteSegments.Root.Config}`,
      title: t('text:navigation.config.title'),
    },
    // Reports are trading data: hidden without the basicBridge feature
    ...(isTradingVisible ? [{
      href: `/${RouteSegments.Root.Reporting}`,
      title: t('text:navigation.reporting.title'),
    }] : []),
    // Markout report is the only Risk Management page, so its visibility hides the whole tab
    ...(isMarkoutVisible ? [{
      href: `/${RouteSegments.Root.RiskManagement}`,
      title: t('text:navigation.riskManagement.title'),
    }] : []),
  ];

  return links;
};
